var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-card",
        { staticClass: "box-card" },
        [
          _c(
            "div",
            {
              staticClass: "clearfix",
              attrs: { slot: "header", id: "device-general" },
              slot: "header",
            },
            [
              _c("span", { staticClass: "header-item" }, [
                _vm._v(_vm._s(_vm.$t("device.general"))),
              ]),
              _vm._v(" "),
              _c(
                "span",
                { staticClass: "ring-card__header-buttons flex flex-row" },
                [
                  _vm.http.warranty.loaded && _vm.delayedFulfillmentEnabled
                    ? _c(
                        "span",
                        {
                          staticClass: "oow-text",
                          staticStyle: {
                            display: "flex",
                            "align-items": "center",
                          },
                        },
                        [
                          _c("StatusTag", {
                            staticStyle: { "font-size": "16px" },
                            attrs: {
                              "status-message": _vm.getFulfillmentStatus(),
                              "disable-tip": !_vm.showFulfillmentReason,
                              "is-error":
                                _vm.getFulfillmentStatus() !==
                                "Fulfillment Standard",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "popover-content",
                                  fn: function () {
                                    return [
                                      _c("FulfillmentReasons", {
                                        attrs: {
                                          reason: _vm.getFulfillmentReason(),
                                        },
                                      }),
                                    ]
                                  },
                                  proxy: true,
                                },
                              ],
                              null,
                              false,
                              1965315137
                            ),
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("span", { staticClass: "flex flex-col" }, [
                    _vm.http.warranty.loaded
                      ? _c(
                          "span",
                          {
                            staticClass: "oow-text",
                            staticStyle: {
                              display: "flex",
                              "align-items": "center",
                            },
                          },
                          [
                            _c("StatusTag", {
                              staticStyle: { "font-size": "16px" },
                              attrs: {
                                "status-message": _vm.warrantyInfo.status,
                                "is-error": !_vm.warrantyInfo.in_warranty,
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "popover-content",
                                    fn: function () {
                                      return [
                                        _c("WarrantyInfo", {
                                          attrs: { data: _vm.warrantyInfo },
                                        }),
                                      ]
                                    },
                                    proxy: true,
                                  },
                                ],
                                null,
                                false,
                                890878321
                              ),
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                  ]),
                  _vm._v(" "),
                  _vm.coverage.eligibility
                    ? _c("EligibilityTags", {
                        staticStyle: {
                          "margin-right": "7px",
                          "font-size": "16px",
                        },
                        attrs: { eligibility: _vm.coverage.eligibility },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("PLCRequestDropdown", {
                    attrs: { eligibility: _vm.coverage.eligibility },
                    on: { "plc-request": _vm.handlePLCRequest },
                  }),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      staticClass:
                        "header-action no-actions with-border-left custom-status-text",
                    },
                    [
                      _c("b", [
                        _vm._v(_vm._s(_vm._f("capitalize")(_vm.plcState))),
                      ]),
                    ]
                  ),
                ],
                1
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              staticClass: "card-content",
            },
            [
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { staticClass: "with-border", attrs: { span: 8 } },
                    [
                      _c("div", { staticClass: "container" }, [
                        _vm.device.name
                          ? _c("div", { staticClass: "device-row-details" }, [
                              _c(
                                "div",
                                { staticClass: "ring-card__input-label" },
                                [
                                  _vm._v(
                                    "\n                Device Name\n              "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("p", { staticClass: "ring-card__input" }, [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(_vm.device.name) +
                                    "\n              "
                                ),
                              ]),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.device.mac_address
                          ? _c("div", { staticClass: "device-row-details" }, [
                              _c(
                                "div",
                                { staticClass: "ring-card__input-label" },
                                [
                                  _vm._v(
                                    "\n                MAC ID\n              "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("p", { staticClass: "ring-card__input" }, [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(
                                      _vm._f("uppercase")(
                                        _vm.device.mac_address
                                      )
                                    ) +
                                    "\n              "
                                ),
                              ]),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        !_vm.device.mac_address && _vm.device.hardware_id
                          ? _c("div", { staticClass: "device-row-details" }, [
                              _c(
                                "div",
                                { staticClass: "ring-card__input-label" },
                                [
                                  _vm._v(
                                    "\n                Hardware ID\n              "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("p", { staticClass: "ring-card__input" }, [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(
                                      _vm._f("uppercase")(
                                        _vm.device.hardware_id
                                      )
                                    ) +
                                    "\n              "
                                ),
                              ]),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.hasRingSolutionsUrl(_vm.device)
                          ? _c(
                              "div",
                              [
                                _c("AlarmDesktopLink", {
                                  attrs: { url: _vm.device.ring_solutions_url },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "device-row-details" }, [
                        _c("div", { staticClass: "ring-card__input-label" }, [
                          _vm._v("\n              Retailer Name\n            "),
                        ]),
                        _vm._v(" "),
                        _c("p", { staticClass: "ring-card__input" }, [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.retailerName) +
                              "\n            "
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "device-row-details" }, [
                        _c("div", { staticClass: "ring-card__input-label" }, [
                          _vm._v(
                            "\n              Retailer Trial Period\n            "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("p", { staticClass: "ring-card__input" }, [
                          _vm._v(
                            "\n              " +
                              _vm._s(
                                _vm.device.retailer
                                  ? _vm.device.retailer.trial_days + " days"
                                  : "N/A"
                              ) +
                              "\n            "
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "device-row-details" }, [
                        _c("div", { staticClass: "ring-card__input-label" }, [
                          _vm._v(
                            "\n              Retailer XLINE\n            "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("p", { staticClass: "ring-card__input" }, [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.retailerXLine) +
                              "\n            "
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "device-row-details" }, [
                        _c("div", { staticClass: "ring-card__input-label" }, [
                          _vm._v("\n              Product\n            "),
                        ]),
                        _vm._v(" "),
                        _c("p", { staticClass: "ring-card__input" }, [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.productDescription) +
                              "\n            "
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "device-row-details" }, [
                        _c("div", { staticClass: "ring-card__input-label" }, [
                          _vm._v("\n              Market\n            "),
                        ]),
                        _vm._v(" "),
                        _c("p", { staticClass: "ring-card__input" }, [
                          _vm._v(
                            "\n              " +
                              _vm._s(
                                _vm._f("capitalize")(
                                  _vm.deviceLocation().market
                                )
                              ) +
                              "\n            "
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "device-row-details" }, [
                        _c("div", { staticClass: "ring-card__input-label" }, [
                          _vm._v("\n              Color\n            "),
                        ]),
                        _vm._v(" "),
                        _c("p", { staticClass: "ring-card__input" }, [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.NA(_vm.device.profile.color)) +
                              "\n            "
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "device-row-details" }, [
                        _c("div", { staticClass: "ring-card__input-label" }, [
                          _vm._v("\n              Current Stock\n            "),
                        ]),
                        _vm._v(" "),
                        _c("p", { staticClass: "ring-card__input" }, [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.NA(_vm.device.profile.current_stock)) +
                              "\n            "
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "device-row-details" }, [
                        _c("div", { staticClass: "ring-card__input-label" }, [
                          _vm._v("\n              Serial number\n            "),
                        ]),
                        _vm._v(" "),
                        _c("p", { staticClass: "ring-card__input" }, [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.NA(_vm.device.profile.serial_number)) +
                              "\n            "
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "device-row-details" }, [
                        _c("div", { staticClass: "ring-card__input-label" }, [
                          _vm._v("\n              Kind\n            "),
                        ]),
                        _vm._v(" "),
                        _c("p", { staticClass: "ring-card__input" }, [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm._f("capitalize")(_vm.device.type)) +
                              "\n            "
                          ),
                        ]),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { staticClass: "with-border", attrs: { span: 8 } },
                    [
                      _c("div", { staticClass: "device-row-details" }, [
                        _c("div", { staticClass: "ring-card__input-label" }, [
                          _vm._v("\n              State\n            "),
                        ]),
                        _vm._v(" "),
                        _c(
                          "p",
                          { staticClass: "ring-card__input" },
                          [
                            _c(
                              "el-popover",
                              {
                                attrs: {
                                  placement: "top-start",
                                  width: "200",
                                  trigger: "hover",
                                },
                              },
                              [
                                _vm.device.deleted_at !== undefined
                                  ? _c(
                                      "span",
                                      { staticClass: "offline-device__icon" },
                                      [
                                        _vm._v(
                                          "Deleted on " +
                                            _vm._s(
                                              _vm._f("moment")(
                                                _vm.device.deleted_at,
                                                "MMMM Do YYYY, h:mm a"
                                              )
                                            )
                                        ),
                                      ]
                                    )
                                  : _vm.device.deactivated_at !== undefined
                                  ? _c(
                                      "span",
                                      { staticClass: "offline-device__icon" },
                                      [
                                        _vm._v(
                                          "Deactivated on " +
                                            _vm._s(
                                              _vm._f("moment")(
                                                _vm.device.deactivated_at,
                                                "MMMM Do YYYY, h:mm a"
                                              )
                                            )
                                        ),
                                      ]
                                    )
                                  : _c(
                                      "span",
                                      { staticClass: "online-device__icon" },
                                      [
                                        _vm._v(
                                          "Activated on " +
                                            _vm._s(
                                              _vm._f("moment")(
                                                _vm.device.created_at,
                                                "MMMM Do YYYY, h:mm a"
                                              )
                                            )
                                        ),
                                      ]
                                    ),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    attrs: { slot: "reference" },
                                    slot: "reference",
                                  },
                                  [
                                    _vm.device.deleted_at !== undefined
                                      ? _c(
                                          "span",
                                          {
                                            staticClass: "offline-device__icon",
                                          },
                                          [
                                            _c(
                                              "el-tag",
                                              {
                                                staticClass: "info-tag",
                                                attrs: {
                                                  size: "medium",
                                                  type: "info",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                      Deleted\n                    "
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm.device.deactivated_at !== undefined
                                      ? _c(
                                          "span",
                                          {
                                            staticClass: "offline-device__icon",
                                          },
                                          [
                                            _c(
                                              "el-tag",
                                              {
                                                staticClass: "info-tag",
                                                attrs: {
                                                  size: "medium",
                                                  type: "info",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                      Deactivated\n                    "
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        )
                                      : _c(
                                          "span",
                                          {
                                            staticClass: "online-device__icon",
                                          },
                                          [
                                            _c(
                                              "el-tag",
                                              {
                                                staticClass: "info-tag",
                                                attrs: {
                                                  size: "medium",
                                                  type: "info",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                      Active\n                    "
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                  ]
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "device-row-details" }, [
                        _c("div", { staticClass: "ring-card__input-label" }, [
                          _vm._v("\n              Status\n            "),
                        ]),
                        _vm._v(" "),
                        _c(
                          "p",
                          { staticClass: "ring-card__input" },
                          [
                            _vm.gettingDeviceStatus
                              ? _c("font-awesome-icon", {
                                  staticClass: "fetching-device-status",
                                  attrs: { icon: "circle-notch", spin: "" },
                                })
                              : _c("font-awesome-icon", {
                                  class: _vm.connectedDesc,
                                  attrs: { icon: "circle" },
                                }),
                            _vm._v(
                              "\n              " +
                                _vm._s(
                                  _vm._f("capitalize")(_vm.connectedDesc)
                                ) +
                                "\n\n              "
                            ),
                            _vm.connectedDesc !== "fetching"
                              ? _c(
                                  "el-button",
                                  {
                                    staticStyle: { padding: "0" },
                                    attrs: { type: "text" },
                                    on: { click: _vm.getDeviceStatus },
                                  },
                                  [_c("i", { staticClass: "el-icon-refresh" })]
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "device-row-details" }, [
                        _c("div", { staticClass: "ring-card__input-label" }, [
                          _vm._v(
                            "\n              AI Active Warnings\n            "
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "p",
                          { staticClass: "ring-card__input" },
                          [
                            _c(
                              "el-tag",
                              {
                                staticClass: "info-tag",
                                attrs: { size: "medium", type: "info" },
                              },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(
                                      _vm.AIActiveWarningsEnabled
                                        ? "Active"
                                        : "Inactive"
                                    ) +
                                    "\n              "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "device-row-details" }, [
                        _c("div", { staticClass: "ring-card__input-label" }, [
                          _vm._v(
                            "\n              Last Kept Alive\n            "
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "p",
                          { staticClass: "ring-card__input" },
                          [
                            _c("time-zone-formatter", {
                              attrs: { "current-time": _vm.lastKeepAlive },
                            }),
                          ],
                          1
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "device-row-details" }, [
                        _c("div", { staticClass: "ring-card__input-label" }, [
                          _vm._v(
                            "\n              Manufactured At\n            "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("p", { staticClass: "ring-card__input" }, [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.formattedManufacturedAt) +
                              "\n            "
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "device-row-details" }, [
                        _c("div", { staticClass: "ring-card__input-label" }, [
                          _vm._v("\n              Network Name\n            "),
                        ]),
                        _vm._v(" "),
                        _c("p", { staticClass: "ring-card__input" }, [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.networkName) +
                              "\n            "
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _vm.canReboot(_vm.device.type)
                        ? _c("div", { staticClass: "device-row-details" }, [
                            _c(
                              "div",
                              { staticClass: "ring-card__input-label" },
                              [_vm._v("\n              Reboot\n            ")]
                            ),
                            _vm._v(" "),
                            _c(
                              "p",
                              { staticClass: "ring-card__input" },
                              [
                                _c("el-button", {
                                  staticStyle: { "margin-top": "10px" },
                                  attrs: {
                                    disabled: !_vm.isOnlineDevice,
                                    type: "success",
                                    size: "medium",
                                    icon: _vm.rebootBtnIcon,
                                    plain: "",
                                  },
                                  on: { click: _vm.rebootDevice },
                                }),
                              ],
                              1
                            ),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c("div", { staticClass: "device_row_details" }, [
                        _c("div", { staticClass: "ring-card__input-label" }, [
                          _vm._v(
                            "\n              " +
                              _vm._s(
                                _vm.isStolen
                                  ? "Device Reported"
                                  : "Report Stolen"
                              ) +
                              "\n            "
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "ring-card__input" },
                          [
                            _c(
                              "el-tooltip",
                              {
                                attrs: {
                                  disabled: _vm.canToggleStolen,
                                  content: "Admin access required",
                                  placement: "top",
                                  effect: "light",
                                  "data-test-id": "stolen-tooltip",
                                },
                              },
                              [
                                _c(
                                  "el-popover",
                                  {
                                    attrs: { placement: "top", width: "275" },
                                    model: {
                                      value: _vm.stolenModal,
                                      callback: function ($$v) {
                                        _vm.stolenModal = $$v
                                      },
                                      expression: "stolenModal",
                                    },
                                  },
                                  [
                                    _c(
                                      "h5",
                                      {
                                        staticStyle: {
                                          "text-align": "center",
                                          margin: "0px 10px 0px",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                    Report Stolen Modal\n                  "
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "p",
                                      {
                                        staticStyle: {
                                          "text-align": "center",
                                          margin: "10px 0px",
                                          "font-size": "13px",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                    " +
                                            _vm._s(
                                              _vm.device.profile.stolen
                                                ? "Are you sure you want remove the stolen flag?"
                                                : "Are you sure you want to report this device as stolen?"
                                            ) +
                                            "\n                  "
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticStyle: {
                                          "text-align": "right",
                                          margin: "0",
                                        },
                                      },
                                      [
                                        _c(
                                          "el-button",
                                          {
                                            attrs: {
                                              disabled: _vm.reportStolenLoading,
                                              size: "mini",
                                              type: "text",
                                            },
                                            on: {
                                              click: function ($event) {
                                                _vm.stolenModal = false
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                      Cancel\n                    "
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-button",
                                          {
                                            attrs: {
                                              disabled: _vm.reportStolenLoading,
                                              size: "mini",
                                              type: "danger",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.confirmReportStolen()
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                      Confirm\n                    "
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c("el-button", {
                                      staticStyle: { "margin-top": "10px" },
                                      attrs: {
                                        slot: "reference",
                                        disabled: !_vm.canToggleStolen,
                                        type: _vm.isStolen ? "danger" : "info",
                                        plain: "",
                                        "data-test-id": "stolen-button",
                                        icon: "el-icon-message-solid",
                                      },
                                      slot: "reference",
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _vm.isFirstClassDevice(_vm.device) || _vm.isCellularParameters
                    ? _c(
                        "el-col",
                        { staticClass: "with-border", attrs: { span: 8 } },
                        [
                          _vm.isFirstClassDevice(_vm.device)
                            ? _c(
                                "div",
                                [
                                  !_vm.isTrackerDevice
                                    ? _c("DiagnosticHealth", {
                                        attrs: {
                                          "report-time-stamp":
                                            _vm.lastStatusReport.timestamp,
                                          diagnostic: _vm.diagnostic,
                                          health: _vm.safeDeviceHealth,
                                        },
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.isTrackerDevice
                                    ? _c("BatteryStatus", {
                                        attrs: {
                                          battery: _vm.device.connection_status,
                                        },
                                      })
                                    : _vm._e(),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.isCellularParameters
                            ? _c("cellular-data", {
                                attrs: { "doorbot-id": _vm.device.doorbot_id },
                              })
                            : _vm._e(),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _vm.device && _vm.newReplacementFormVisible
            ? _c("replacement-form", {
                ref: "replacement",
                attrs: {
                  visible: _vm.newReplacementFormVisible,
                  device: _vm.device,
                  eligibility: _vm.coverage.eligibility,
                  "is-supervisor": _vm.isSupervisor,
                },
                on: {
                  "update:visible": function ($event) {
                    _vm.newReplacementFormVisible = $event
                  },
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.device
            ? _c("parts-modal-form", {
                ref: "parts",
                attrs: { device: _vm.device },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.device
            ? _c("refund-modal-form", {
                ref: "refund",
                attrs: { device: _vm.device },
              })
            : _vm._e(),
          _vm._v(" "),
          _c("out-of-warranty-warning-modal", {
            ref: "outOfWarrantyWarningModal",
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }